webpackJsonp([271960865160630],{

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TexasImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TexasLocation = function (_React$Component) {
	  _inherits(TexasLocation, _React$Component);
	
	  function TexasLocation() {
	    _classCallCheck(this, TexasLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TexasLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Texas' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Govt\u2014State + Local',
	        title: 'Bike in the Heart of Texas',
	        story: 'Our PlacesForBikes team visited all 10 Big Jump cities this year: Austin, Baltimore, Fort Collins, Los Angeles, Memphis, New Orleans, New York City, Portland, Providence and Tucson. In Austin the team met with elected officials, business leaders, high-level city staff, and local advocates. A city hall meeting was followed by a reception where the Mayor spoke of his time in northern Europe in 2016 with then U.S. Secretary of Transportation Anthony Foxx. He described the power of experiencing biking in those cities and how it shaped his perspective for Austin\u2019s future.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Texas 1-1',
	        alt: 'Austin BigJump meeting',
	        sizes: this.props.data.texasOneOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Nothing Like a Bike',
	        story: 'Our spring campaign, Nothing Like a Bike, featured personal stories from people with life experiences that never would have happened without bikes. From breathtaking travel to true love, these stories affirmed that bikes have a special ability to change lives. Contest entrants shared nearly 700 personal stories for a chance to win a new Fuji bike, and Bill from Texas was the lucky winner. In his submitted story he wrote, "Cycling isn\u2019t just about who\u2019s the fastest, or who rides the most miles. Cycling is about having fun as you push on the pedals."'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Texas 2-1',
	        alt: 'Nothing Like a Bike writing contest',
	        sizes: this.props.data.texasTwoOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Portland, OR',
	        prevLocationPath: 'portland',
	        prevLocationImgPath: this.props.data.texasPrevImage,
	        nextLocationName: 'Memphis, TN',
	        nextLocationPath: 'memphis',
	        nextLocationImgPath: this.props.data.texasNextImage
	      })
	    );
	  };
	
	  return TexasLocation;
	}(_react2.default.Component);
	
	exports.default = TexasLocation;
	
	// GraphQL query
	
	var TexasImageQuery = exports.TexasImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-texas-js-847c25e2486ff8be4c71.js